/**
 * @author       Yannick Deubel (https://github.com/yandeu)
 * @copyright    Copyright (c) 2020 Yannick Deubel; Project Url: https://github.com/enable3d/enable3d
 * @license      {@link https://github.com/enable3d/enable3d/blob/master/LICENSE|GNU GPLv3}
 */
import * as THREE from 'three';
import Cameras from './plugins/cameras';
import { AmmoPhysics } from '@enable3d/ammo-physics/dist/index';
import { logger } from '@enable3d/common/dist/logger';
export class ThreeGraphics {
    constructor(threeGraphicsConfig = {}) {
        this.threeGraphicsConfig = threeGraphicsConfig;
        const { alpha = false, anisotropy = 1, camera = Cameras.Perspective({ z: 25, y: 5 }), antialias = false, usePhysics = true, renderer } = threeGraphicsConfig;
        this.textureAnisotropy = anisotropy;
        this.camera = camera;
        this.scene = new THREE.Scene();
        // this.renderer.physicallyCorrectLights = true
        this.renderer = renderer || new THREE.WebGLRenderer({ antialias, alpha });
        // see https://threejs.org/docs/#examples/en/loaders/GLTFLoader
        // this.renderer.outputEncoding = sRGBEncoding
        // shadow
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        // enable cache
        this.cache = THREE.Cache;
        this.cache.enabled = true;
        if (usePhysics) {
            if (typeof Ammo !== 'undefined')
                this.physics = new AmmoPhysics(this.scene, threeGraphicsConfig);
            else
                logger('Are you sure you included ammo.js?');
        }
    }
}
//# sourceMappingURL=core.js.map